import { BuyOrSell, OrderTypes } from "@shared/types";

export const CUSTOM_STRATEGIES_ITEM_NAME = "Custom Strategies";
export const DCA_STRATEGIES_ITEM_NAME = "DCA Strategies";
export const TRIGGER_TYPE_ITEM_NAME = "Trigger Type";
export const TRIGGER_VALUE_ITEM_NAME = "Trigger Value";
export const TRIGGER_ITEM_NAME = "Trigger";
export const TRAILING_PERCENT_ITEM_NAME = "Trailing Percent";
export const TRAILING_STOP_TYPE_ITEM_NAME = "Type";
export const NUMBER_OF_ORDERS_ITEM_NAME = "Number of Orders";
export const PRICE_RANGE_ITEM_NAME = "Price Range";
export const TRAILING_STOP_ITEM_NAME = "Trailing Stop";
export const TRAILING_TYPE_ITEM_NAME = "Trailing Type";

export const INVALID_GROUP_AUTO_TRADING_WARNING =
  "You are no longer a member of this group.";
export const INACTIVE_GROUP_AUTO_TRADING_WARNING =
  "This group is no longer integrated with Cornix.";

export const ORDER_TYPE_TO_BUY_OR_SELL = {
  [OrderTypes.ENTRY]: BuyOrSell.ENTRY,
  [OrderTypes.TAKE_PROFIT]: BuyOrSell.TAKE_PROFIT,
};

export const SIGNALS_BOTS_MIGRATION_BANNER_TITLE =
  "Signals bots are the way to follow signals using Cornix";

export const NO_REAL_ACCOUNT_CONNECTED_MESSAGE =
  "To begin trading with Cornix, please connect a real exchange account.";
